import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatDate, formatEUR, FACTURE_STATUSES } from "@/lib/api";
import { PageHeader, SelectField, EmptyState, MetricCard } from "@/components/ui-kit";
import StatusBadge from "@/components/StatusBadge";
import { FileText, PiggyBank, Clock, AlertTriangle } from "lucide-react";

export default function Factures() {
  const [items, setItems] = useState([]);
  const [statutFilter, setStatutFilter] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/dossiers").then((r) => {
      const arr = statutFilter ? r.data.filter((d) => d.facture_statut === statutFilter) : r.data;
      setItems(arr);
    }).finally(() => setLoading(false));
  }, [statutFilter]);

  const stats = {
    a_emettre: items.filter((d) => d.facture_statut === "a_emettre").length,
    envoyees: items.filter((d) => d.facture_statut === "envoyee").length,
    payees: items.filter((d) => d.facture_statut === "payee").length,
    total_commission_encaissee: items.filter((d) => d.facture_statut === "payee").reduce((s, d) => s + (d.commission_montant || 0), 0),
  };

  return (
    <div className="p-8" data-testid="factures-page">
      <PageHeader title="Factures" subtitle="Facturation promoteur" />

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <MetricCard label="À émettre" value={stats.a_emettre} icon={FileText} tone="warning" testid="fact-metric-emettre" />
        <MetricCard label="Envoyées" value={stats.envoyees} icon={Clock} tone="primary" testid="fact-metric-envoyees" />
        <MetricCard label="Payées" value={stats.payees} icon={PiggyBank} tone="success" testid="fact-metric-payees" />
        <MetricCard label="CA encaissé" value={formatEUR(stats.total_commission_encaissee)} icon={PiggyBank} tone="gold" testid="fact-metric-ca" />
      </div>

      <div className="bg-white rounded-sm border border-slate-200 mb-6 p-4 max-w-xs">
        <SelectField testid="fact-filter" label="Statut facture" value={statutFilter} onChange={(e) => setStatutFilter(e.target.value)}
          options={[{ value: "", label: "Toutes" }, ...FACTURE_STATUSES]} />
      </div>

      <div className="bg-white rounded-sm border border-slate-200 overflow-hidden">
        {loading ? <div className="p-10 text-center text-slate-500">Chargement…</div> :
          items.length === 0 ? <EmptyState icon={FileText} title="Aucune facture" /> :
          <table className="w-full text-sm">
            <thead className="bg-slate-50"><tr>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">N° facture</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Client</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Promoteur</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Statut</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Envoi</th>
              <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Paiement</th>
              <th className="text-right px-4 py-3 font-semibold uppercase text-xs">Commission</th>
            </tr></thead>
            <tbody>{items.map((d) => (
              <tr key={d.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 font-mono text-xs">{d.facture_numero || "—"}</td>
                <td className="px-4 py-3"><Link to={`/dossiers/${d.id}`} className="font-semibold text-[#111111] hover:text-[#B8873A]">{d.client_prenom} {d.client_nom}</Link></td>
                <td className="px-4 py-3">{d.promoteur || "—"}</td>
                <td className="px-4 py-3"><StatusBadge value={d.facture_statut} kind="facture" /></td>
                <td className="px-4 py-3">{formatDate(d.facture_date_envoi)}</td>
                <td className="px-4 py-3">{formatDate(d.facture_date_paiement)}</td>
                <td className="px-4 py-3 text-right font-semibold">{formatEUR(d.commission_montant)}</td>
              </tr>))}
            </tbody>
          </table>}
      </div>
    </div>
  );
}
